module.exports = __webpack_public_path__ + "img/201604-5-683x1024.1295630b.jpg";